import ToggleFFXIV from '@/app/components/ToggleFFXIV'
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useTranslation } from '@/hooks/useTranslation';
import { CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import React from 'react'

const CompassSelector = () => {
    const { t } = useTranslation();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    const handleCompassToggle = (compassDisabled: boolean) => {
        if (isGameMaster) {
            updateSettings({ compassDisabled } as Partial<CustomModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    if (!('compassDisabled' in settings)) {
        return null;
    }

    const customSettings = settings as CustomModeSettings;

    return (
        <ToggleFFXIV
            value={customSettings.compassDisabled}
            onChange={handleCompassToggle}
            text={t('game.modes.custom.disableCompass')}
            shape="square"
        />
    )
}

export default CompassSelector
